// extracted by mini-css-extract-plugin
export default {"postHeader":"PostHeader-module--postHeader--3094d"};